import { Card, Center, Stack, Text } from '@mantine/core'
import { underAgeMessage } from 'macrotide-shared'

import { DeleteAccountAction } from './DeleteAccountAction'

/**
 * Replaces the signed-in app (from `AgeGate`) or stops guided setup (from `SetupPage`'s step 1) once a birth date
 * says the account holder is under 18 (shared/ `AgeGate.isAdult`, owner decision: Macrotide is 18+). The only way
 * forward from here is deleting the account.
 */
export function UnderAgeScreen() {
  return (
    <Center mih="100vh" p="md">
      <Card padding="lg" maw={480} w="100%">
        <Stack gap="md">
          <Text fw={600} fz="lg">
            {underAgeMessage()}
          </Text>
          <DeleteAccountAction />
        </Stack>
      </Card>
    </Center>
  )
}
